export function getDeviceBenchmark(): number {
    const t0 = performance.now();

    for (let i = 0; i < 1e6; i++) {
        Math.sqrt(i);
    }

    const t1 = performance.now();
    return t1 - t0;
}
